export default __webpack_public_path__ + "static/media/bankTransfer.3efe1929.webp";